import { request } from '@/shared/api/request'

export const deleteLocalContract = (externalId) =>
	request({ url: `contract/deleteLocal/${externalId}`, method: 'DELETE' })
